import React from 'react';
import { IonicButton } from 'ionic-ui';
import { useDialog } from '../../../../context/Dialog';
import ResponsiveImage from '../../../responsive-image/ResponsiveImage';
import images from '../../../../assets/images';

export default function StepThree() {
  const { closeDialog } = useDialog();
  const handleClick = () => closeDialog();
  return (
    <div className="space-y-4 text-center dialog-content max-w-80 mx-auto my-auto relative">
      <div className="w-full">
        <ResponsiveImage aspectRatio={4 / 3} src={images.productCreationImg} />
      </div>
      <h5 className="high-emphasis-text font-bold">Product Saved to Catalog</h5>
      <p className="medium-emphasis-text">
        Your product has been successfully saved to catalog
      </p>
      <IonicButton className="w-full" variant="outline" onClick={handleClick}>
        View Product
      </IonicButton>
    </div>
  );
}
